// src/components/form/input.js

import React, { useRef } from "react";

export default function Input({
  type,
  placeholder,
  value,
  onChange = () => {},
  label,
  id,
  children,
  required,
  error,
}) {
  const handleClick = () => {
    // focus the input
    inputRef.current.focus();
  };
  const inputRef = useRef(null);

  return (
    <div className="input-container my-4" onClick={handleClick}>
      <label
        htmlFor={id}
        className={`text-lg py-3 block font-[500] ${error && "text-red-500"}`}
      >
        {label}
      </label>
      <div
        className={`input-wrapper flex items-center gap-2 justify-center border border-gray-300 rounded-md
      focus-within:border-[#F15213]
      focus-within:shadow-md h-[60px] shadow-inner pl-2
      ${
        error &&
        "border-red-500 focus-within:border-red-500 focus-within:shadow-red-500 text-red-500"
      } 
      `}
      >
        <span className={`icon w-10 ${error && "text-red-500 fill-red-500"}`}>
          {children}
        </span>
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={` pl-5 input w-full h-full outline-none text-lg focus:outline-none focus:ring-0 focus:border-none focus:shadow-none active:outline-none active:ring-0 active:border-none active:shadow-none
          ${
            error &&
            "text-red-500 focus-within:text-red-500 placeholder:text-red-500"
          }
          `}
          ref={inputRef}
          required={required}
          name={id}
        />
      </div>
      {error && <p className="text-red-500 text-sm mt-2 mb-0">{error}</p>}
    </div>
  );
}
